import { createContext, type RefObject } from 'react';

import { _SelectionRef } from '../../core/components/selection-area/types.js';

export const HistogramSelectionAreaRef = createContext<
  RefObject<_SelectionRef | null> | undefined
>(undefined);
